import styled from 'styled-components'

const StyledAdminPageLayout = styled.div`
  .width-controller-container {
    padding: 1rem 0;
  }
`

export default StyledAdminPageLayout
